import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconAccessibility } from "@/components/_icons/IconAccessibility";
import { IconQuestionCircled } from "@/components/_icons/IconQuestionCircled";
import { IconVideo } from "@/components/_icons/IconVideo";
import {
  SUPPORT_EMAIL,
  VIDEO_TUTORIALS_URL,
} from "@/domain/_shared/constants/support-email";

export function ButtonHelp() {
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-initial flex-col gap-2 text-xs">
      <a
        href={VIDEO_TUTORIALS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex min-h-6 items-center overflow-hidden text-ellipsis rounded-sm hover:bg-accent hover:text-accent-foreground focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus"
      >
        <IconVideo className="mr-2 h-4 w-4" aria-hidden="true" />
        {t("videoTutorials")}
      </a>
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        target="_blank"
        className="relative flex min-h-6 items-center overflow-hidden text-ellipsis rounded-sm hover:bg-accent hover:text-accent-foreground focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus"
      >
        <IconQuestionCircled className="mr-2 h-4 w-4" aria-hidden="true" />
        {t("contactSupport")}
      </a>
      <Link
        to="/accessibility"
        className="relative flex min-h-6 items-center overflow-hidden text-ellipsis rounded-sm hover:bg-accent hover:text-accent-foreground focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus"
      >
        <IconAccessibility className="mr-2 h-4 w-4" aria-hidden="true" />
        {t("accessibilityStatement")}
      </Link>
    </div>
  );
}
